<template>
  <div class="home">
    <Swiper1></Swiper1>
    <div class="story">
      <div>
        <img
          src="/static/img/about.jpg"
          alt="蓝鲨 Robor 智能电动摩托车"
          width="100%"
        />
      </div>
      <div class="stotips">
        <div class="stoname">Sharkgulf Technologies Group Limited</div>
        <div class="stocontent">
          是一家打造智慧電動車輛系統及服務的國際化科技公司，致力於用汽車科技重塑電動機車行業，
        </div>
        <div class="stocontent">
          為用戶提供適用於中短途出行的高科技解決方案。
        </div>
        <div class="stobtn ">
          <button @click="reaUs" class="btn">聯絡我們</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper1 from '../swiper_tw/swiper1.vue'
export default {
  data() {
    return {
      homelist: [],
      formore: false
    }
  },
  mounted() {
    let that = this
    window.scrollTo(0, 0)
    this.$nextTick(function() {
      window.addEventListener('scroll', that.animateTxt)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  components: {
    Swiper1
  },
  methods: {
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
    },
    goProduct() {
      this.$router.push('/tc/robor')
    },
    reaUs() {
      this.$router.push('/tc/contactus')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.home {
  color: #fff;
  background: #000;
  padding-top: 60px;
  .product {
    position: relative;
    .gda {
      position: absolute;
      top: 75px;
      right: 22%;
    }
    .protips {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      .proname {
        font-size: 40px;
        margin-bottom: 12px;
        height: 48px;
        line-height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          font-size: 48px;
        }
        .namelogo {
          width: 132px;
          height: 44px;
          background: url(/static/img/Robor.png) no-repeat;
          background-size: 100%;
          margin-left: 20px;
        }
      }
      .procontent {
        margin-bottom: 60px;
        height: 28px;
        line-height: 28px;
        font-size: 24px;
      }
      .probtn {
        width: 240px;
        box-sizing: border-box;
      }
      .proinfobox {
        width: 100%;
        background: rgba(255, 255, 255, 0.1);
        .proinfo {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100px;
          width: 66.67%;
          margin: 0 auto;
          text-align: start;
          font-size: 24px;
          .arkride {
            position: relative;
            .arktm {
              position: absolute;
              top: 2;
              left: 86px;
              font-size: 12px;
            }
            .arkright {
              margin-right: 20px;
            }
          }
        }
        .proinfo_tip {
          width: 66.67%;
          margin: 0 auto;
          text-align: center;
          color: #999;
          font-size: 14px;
          line-height: 38px;
        }
      }
    }
  }
  .news {
    padding: 5vw 0;
    width: 66.67%;
    margin: 0 auto;
    h3 {
      margin-bottom: 31px;
      font-size: 26px;
    }
    .newlist {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(31, 31, 31, 1);
      margin-bottom: 33px;
      padding-bottom: 33px;
      .new {
        width: 30%;
        cursor: pointer;
        .nimg {
          overflow: hidden;
          margin-bottom: 18px;
          img {
            width: 100%;
          }
        }
        .csimg {
          height: 11.12vw;
          margin-bottom: 18px;
          // background-image:url(/static/img/in/kv.jpg) ;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        }
        .ncf {
          font-size: 14px;
          color: #666;
        }
        .ncontent {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 24px;
        }
        .ntitle {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin: 10px 0;
          font-size: 20px;
          line-height: 30px;
          height: 60px;
        }
        .ntitle:hover {
          color: @colorblue;
        }
      }
    }
    .more {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 12px;
      height: 20px;
      cursor: pointer;
      line-height: 20px;
      .arrow {
        margin-left: 12px;
        width: 8px;
        height: 8px;
        border-top: 1px solid #666;
        border-right: 1px solid #666;
        transform: rotate(45deg);
      }
      .arrowblue {
        border-top: 1px solid @colorblue;
        border-right: 1px solid @colorblue;
      }
    }
    .more:hover {
      color: @colorblue;
    }
  }
  .story {
    position: relative;
    text-align: center;
    .stotips {
      position: absolute;
      height: 230px;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .stoname {
        font-size: 48px;
        margin-bottom: 27px;
      }
      .stocontent {
        font-size: 16px;
        color: #fff;
        line-height: 36px;
      }
      .stobtn {
        padding: 25px 0;
        button {
          box-sizing: border-box;
          width: 240px;
          font-size: 18px;
          background: rgba(0, 0, 0, 0);
          color: #fff;
          outline: none;
        }
        button:hover {
          background: #fff;
          color: #000;
        }
      }
    }
  }
}
.home img {
  display: block;
}
.btn {
  box-sizing: border-box;
  height: 45px;
  border-radius: 23px;
  line-height: 41px;
  border: 2px solid #fff;
  text-align: center;
  cursor: pointer;
}
.btn:hover {
  background: #fff;
  color: #000;
}
.swiper-button-prev {
  background-image: url('/static/img/buttonbg.png');
  background-size: 100%;
  width: 30px;
  height: 30px;
  top: 80%;
  margin-top: 12px;
  left: 70px;
}
.swiper-button-next {
  background-image: url('/static/img/buttonbg.png');
  background-size: 100%;
  width: 30px;
  height: 30px;
  top: 80%;
  margin-top: 12px;
  right: 70px;
}
@media screen and (max-width: 1640px) {
  // .fs_normal{
  //   font-size: 20px;
  // }
  // .arktm{
  //   left: 70px!important;
  // }
  .proinfo {
    width: 1080px !important;
  }
  .news {
    width: 1080px !important;
  }
  .csimg {
    height: 182px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tw/home.vue